const EVENTS = ['formCreated', 'formConfirmed', 'formUpdated', 'beforeUpdate', 'beforeSave', 'userCreated', 'formArchived',
  'newPasswordGenerated', 'storageItemBelowZero', 'formsIndexLoaded', 'formViewLoaded', 'newSubFormRecordProcessed']
export default class EventActionType{

  static getEventName(event) {
    switch (event) {
    case "formCreated":
      return "Po utworzeniu formularza"
    case "formConfirmed":
      return "Po potwierdzeniu formularza"
    case "formArchived":
      return "Po archiwizacji"
    case "formsIndexLoaded":
      return "Po wczytaniu formularzy"
    case "formViewLoaded":
      return "Po wczytaniu formularza"
    case "beforeUpdate":
      return "Przed aktualizacja  formularza"
    case "formUpdated":
      return "Po aktualizacji  formularza"
    case "newSubFormRecordProcessed":
      return "Po przeprocesowaniu rekordu w tabeli podczas dodawania nowego formularza"
    case "beforeSave":
      return "Po zapisaniem formularza"
    case "userCreated":
      return "Po utworzeniu użytkownika"
    case "newPasswordGenerated":
      return "Po wygenerowaniu nowego hasła dla użytkownika"
    case "storageItemBelowZero":
      return "Gdy ilość sztuk na magazynie spadnie poniżej 0 "
    }
  }

  static getEventsToSelect(eventsToShow) {
    let eventsToSelect = []

    eventsToShow.forEach(eventType => {
      if (!EVENTS.includes(eventType)) {
        return
      }

      eventsToSelect.push({
        'name': this.getEventName(eventType),
        'value': eventType
      })
    })

    return eventsToSelect
  }
}